export function ExpandIcon({className}: {className?: string}) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="presentation"
      className={className}
    >
      <g clipPath="url(#clip0_6911_7629)" fill="currentColor">
        <path d="M14.722 6.047a.75.75 0 11-1.5 0V3.615L10.2 6.638a.75.75 0 01-1.06-1.06l3.023-3.024H9.729a.75.75 0 010-1.499h4.243a.75.75 0 01.75.75v4.242zM1.278 9.953a.75.75 0 111.5 0v2.432L5.8 9.362a.75.75 0 011.06 1.06l-3.023 3.024h2.433a.75.75 0 010 1.499H2.028a.75.75 0 01-.75-.75V9.953z" />
      </g>
      <defs>
        <clipPath id="clip0_6911_7629">
          <path fill="#fff" d="M0 0H16V16H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
